"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PLATFORM = void 0;
exports.PLATFORM = {
    MOBILE: 'mobile',
    WEB: 'web',
};
//# sourceMappingURL=platform.js.map